import { render, staticRenderFns } from "./TariffsAdminView.vue?vue&type=template&id=5ed3181f&scoped=true"
import script from "./TariffsAdminView.vue?vue&type=script&lang=js"
export * from "./TariffsAdminView.vue?vue&type=script&lang=js"
import style0 from "./TariffsAdminView.vue?vue&type=style&index=0&id=5ed3181f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3181f",
  null
  
)

export default component.exports